import { ScrollbarPlugin } from 'smooth-scrollbar'

export default class DisableScrollPlugin extends ScrollbarPlugin {
  static pluginName = 'disableScroll';

  static defaultOptions = {
    direction: null,
    paused: false,
  };

  transformDelta (delta) {
    if (this.options.paused) {
      return this.options.paused ? { x: 0, y: 0 } : delta;
    } else if (this.options.direction) {
      delta[this.options.direction] = 0
    }
    return { ...delta }
  }
}
